import React from "react"
import styled from "@emotion/styled"
import { Flex, Box } from "@rebass/grid/emotion"

import theme from "@nutrafol/nutrafol-ui-kit/styles/theme"
import { TextElementNova } from "@nutrafol/nutrafol-ui-kit/dist/TextElementNova"
import Bullet from "../../../../assets/icons/nova/bullet-orange.svg"

const StsWrapper = styled(Box)`
  padding: 0 2px;
`

const StatsWrap = styled(Flex)`
  flex-wrap: wrap;
  gap: 8px;
`

const StatBase = styled(Flex)`
  align-items: flex-start;
  gap: 32px;
  padding: 32px;
  @media (min-width: 768px) {
    padding: 24px;
  }
  @media (min-width: 1024px) {
    padding: 32px 56px 32px 32px;
  }
`

const Stat = styled(StatBase)`
  flex-direction: column;

  background: ${theme.wild.color.nova.base.black};
  border-radius: 4px;
`

const StatAlt = styled(StatBase)`
  background: ${theme.wild.color.nova.base.black};
  border-radius: 4px;
  flex-direction: column;
  @media (min-width: 768px) {
    padding: 24px;
  }
  @media (min-width: 1024px) {
    padding: 32px;
  }
`

const Divider = styled(Box)`
  display: none;
  @media (min-width: 768px) {
    position: relative;
    width: 100%;
    height: 1px;
    background: linear-gradient(
      to right,
      #687676 0%,
      #687676 25%,
      transparent 25%,
      transparent 100%
    );
    background-size: 8px 1px;
    background-repeat: repeat-x;
    display: flex;
    align-items: center;
    svg {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
    }
  }
  @media (min-width: 1024px) {
    margin: 6px 0;
  }
`
const StsImageArea = ({ data }) => {
  return (
    <StsWrapper>
      <Stat mb={[8]}>
        <Box py={[0, 0, 45, 0]}>
          <TextElementNova
            text={data.title}
            className="sts-title text-nova-base-white "
            classes={{
              default: "Title-30-Super-Normal",
              768: "Title-20-Super-Normal",
              1024: "Title-20-Super-Normal",
            }}
          />
        </Box>
      </Stat>
      <StatsWrap>
        {data.stats.map((stat, index) => (
          <React.Fragment key={index}>
            {index < 2 ? (
              <Stat
                width={[1, 1, "calc(50% - 4px)"]}
                minHeight={[null, null, null, 185]}
              >
                <Box>
                  <TextElementNova
                    text={stat.title}
                    className="number text-nova-base-white Title-20-Super-Normal"
                  />
                </Box>
                <TextElementNova
                  text={stat.copy}
                  className="copy   text-nova-base-white Body-20-Dia-Normal"
                />
              </Stat>
            ) : (
              <StatAlt width={1}>
                <Box>
                  <TextElementNova
                    text={stat.title}
                    className="number  text-nova-base-white Title-20-Super-Normal"
                  />
                </Box>
                <Divider>
                  <Bullet />
                </Divider>
                <Flex width={1}>
                  <Box width={[0, 0, 0.6, 1 / 2]} />
                  <Box width={[1, 1, 0.4, 1 / 2]}>
                    <TextElementNova
                      text={stat.copy}
                      className="copy text-nova-base-white Body-20-Dia-Normal"
                    />
                  </Box>
                </Flex>
              </StatAlt>
            )}
          </React.Fragment>
        ))}
      </StatsWrap>
    </StsWrapper>
  )
}

export default StsImageArea
